import { MutableRecordStore } from '@deqo/foundation';
import { MyBoardData } from '../../api/endpoints/boards';

const template = {
    id: '',
    workspaceId: null as string,
    folderId: null as string,
    label: '',
    type: null as number,
    workspaceLabel: '',
    workspaceType: '',
    path: '',
    thumbUrl: null as string,
    createdAt: new Date(1970),
    updatedAt: new Date(1970),
    lastSeenAt: null,
};

export class AllBoardModel extends MutableRecordStore(template) {

    public static create(data: MyBoardData) {
        const m = new AllBoardModel();
        m.updateState({
            id: data.id,
            workspaceId: data.workspaceId,
            folderId: data.folderId,
            label: data.label,
            type: data.type,
            workspaceLabel: data.workspaceLabel,
            workspaceType: data.workspaceType,
            path: `~/${data.id}`,
            thumbUrl: data.thumbUrl,
            createdAt: data.createdAt,
            updatedAt: data.updatedAt,
            lastSeenAt: data.lastSeenAt,
        });
        return m;
    }
}
